import { filter } from 'rxjs/operators';

import { isStartupError, isMidStreamError, isUnknownError } from '../Utils/cdnErrorFilters';

const createRotationErrorsStream = errors$ =>
    errors$
        .pipe(
            filter(error => (
                isUnknownError(error) ||
                isStartupError(error) ||
                isMidStreamError(error)
            ))
        );

export default createRotationErrorsStream;
